// src/Chatbot.js
// 351936959768

import React, { useState } from 'react';
// Importe as imagens dos pastores. Certifique-se que estão na pasta `src`.
import pastorPedroImg from './pastor_pedro.png';
import pastoraSandraImg from './pastora_sandra.png';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState('initial'); // 'initial', 'pedro', 'sandra'
  const [message, setMessage] = useState('');
  const [selectedPastor, setSelectedPastor] = useState('');

  // IMPORTANTE: Substitua pelo número de WhatsApp real (com código do país, sem '+')
  const numeroWhatsApp = '351936959768'; 

  const handleSelectPastor = (pastor) => {
    setSelectedPastor(pastor);
    setStep(pastor.toLowerCase());
  };

  const handleSendMessage = () => {
    if (message.trim() === '') {
      alert('Por favor, escreve a tua mensagem.');
      return;
    }

    const fullMessage = `Olá! Gostarias de deixar uma mensagem, com preferência de contacto pelo(a) Pastor(a) ${selectedPastor}.\n\nMensagem: ${message}`;
   const whatsappUrl = `https://api.whatsapp.com/send?phone=${numeroWhatsApp}&text=${encodeURIComponent(fullMessage )}`;

    window.open(whatsappUrl, '_blank');

    // Reset para o estado inicial depois de enviar
    setTimeout(() => {
      setIsOpen(false);
      setStep('initial');
      setMessage('');
      setSelectedPastor('');
    }, 1000);
  };

  return (
    <>
      {/* Ícone Flutuante do Chatbot (Vermelho) */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-red-600 text-white w-16 h-16 rounded-full shadow-lg flex items-center justify-center hover:bg-red-700 transition-transform hover:scale-110"
          aria-label="Abrir chat"
        >
          {/* Ícone de Fechar (X) ou Abrir (Chat) */}
          {isOpen ? (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          ) : (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg>
          )}
        </button>
      </div>

      {/* Janela do Chat (Preto, Vermelho, Branco) */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-96 bg-black rounded-lg shadow-2xl z-50 border-2 border-red-600 flex flex-col">
          {/* Header do Chat (Preto com borda vermelha) */}
          <div className="bg-black p-4 text-white rounded-t-md border-b-2 border-red-600">
            <h3 className="font-bold text-lg">Fala Connosco</h3>
            <p className="text-sm text-gray-300">Estamos aqui para te ajudar.</p>
          </div>

          {/* Corpo do Chat */}
          <div className="p-6 flex-grow">
            {step === 'initial' && (
              <div className="text-center">
                <p className="text-white mb-6">Olá! Com quem gostarias de falar?</p>
                <div className="flex justify-center space-x-6">
                  {/* Botão Pastor Pedro */}
                  <button onClick={() => handleSelectPastor('Pedro')} className="flex flex-col items-center text-center group">
                    <img src={pastorPedroImg} alt="Pastor Pedro" className="w-24 h-24 rounded-full border-4 border-gray-700 group-hover:border-red-500 transition-all duration-300" />
                    <span className="mt-2 font-semibold text-white group-hover:text-red-500">Pastor Pedro</span>
                  </button>
                  {/* Botão Pastora Sandra */}
                  <button onClick={() => handleSelectPastor('Sandra')} className="flex flex-col items-center text-center group">
                    <img src={pastoraSandraImg} alt="Pastora Sandra" className="w-24 h-24 rounded-full border-4 border-gray-700 group-hover:border-red-500 transition-all duration-300" />
                    <span className="mt-2 font-semibold text-white group-hover:text-red-500">Pastora Sandra</span>
                  </button>
                </div>
              </div>
            )}

            {/* Mensagens de saudação dos pastores */}
            {(step === 'pedro' || step === 'sandra') && (
              <div className="text-left">
                <p className="bg-gray-800 text-white p-3 rounded-lg inline-block">
                  {step === 'pedro' 
                    ? "Olá, sou o Pastor Pedro. Em que te posso ajudar?" 
                    : "Olá, sou a Pastora Sandra. Em que te posso ajudar?"}
                </p>
              </div>
            )}
          </div>

          {/* Input de Mensagem (aparece após escolher o pastor) */}
          {(step === 'pedro' || step === 'sandra') && (
            <div className="p-4 border-t border-gray-700 bg-black rounded-b-lg">
              <textarea
                className="w-full p-3 border border-gray-600 bg-gray-900 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 placeholder-gray-500"
                rows="4"
                placeholder="Escreva a sua mensagem aqui..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <button
                onClick={handleSendMessage}
                className="w-full mt-3 bg-red-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-red-700 transition-colors flex items-center justify-center space-x-2"
              >
                {/* Ícone do WhatsApp */}
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.267.651 4.383 1.89 6.206l-.476 1.748 1.788-.464z"/></svg>
                <span>Enviar via WhatsApp</span>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Chatbot;
